import { ExpandableDebugItem } from "./ExpandableDebugItem";
import { Button } from "@/components/Button/Button";
import { Modal } from "@/components/Modal/Modal";
import { useAppSelector } from "@/hooks/types";
import { getImporterDebug } from "@/store/debug/selectors";
import { getIsModalOpen } from "@/store/modal/selectors";
import { ModalTypes } from "@/types/modal";

const ImporterDebugModal = () => {
    const isOpen = useAppSelector(
        getIsModalOpen(ModalTypes.IMPORT_RESUME_DEBUG),
    );
    const importerDebugDetails = useAppSelector(getImporterDebug) ?? {};

    const openDebugDetailsInNewTab = () => {
        const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Importer Debug Details</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 2rem; }
    .item { margin-bottom: 2rem; border-bottom: 1px solid #ccc; padding-bottom: 1rem; }
    .key { font-weight: bold; font-size: 1.2em; }
    .value { white-space: pre-wrap; background: #f9f9f9; padding: 1em; border-radius: 4px; margin-top: 0.5em; }
    pre { white-space: pre-wrap; word-wrap: break-word; }
  </style>
</head>
<body>
  <h1>Importer Debug Details</h1>
  ${Object.entries(importerDebugDetails)
      .map(
          ([key, value]) => `
      <div class="item">
        <div class="key">${key}</div>
        <div class="value">${
            typeof value === "string" && value.trim().startsWith("{")
                ? "<pre>" +
                  JSON.stringify(JSON.parse(value), null, 2) +
                  "</pre>"
                : value
        }
        </div>
      </div>
    `,
      )
      .join("")}
</body>
</html>
        `;
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
    };

    const downloadDebugDetailsAsHtml = () => {
        const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Importer Debug Details</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 2rem; }
    .item { margin-bottom: 2rem; border-bottom: 1px solid #ccc; padding-bottom: 1rem; }
    .key { font-weight: bold; font-size: 1.2em; }
    .value { white-space: pre-wrap; background: #f9f9f9; padding: 1em; border-radius: 4px; margin-top: 0.5em; }
    pre { white-space: pre-wrap; word-wrap: break-word;}
  </style>
</head>
<body>
  <h1>Importer Debug Details</h1>
  ${Object.entries(importerDebugDetails)
      .map(
          ([key, value]) => `
      <div class="item">
        <div class="key">${key}</div>
        <div class="value">${
            typeof value === "string" && value.trim().startsWith("{")
                ? "<pre>" +
                  JSON.stringify(JSON.parse(value), null, 2) +
                  "</pre>"
                : value
        }
        </div>
      </div>
    `,
      )
      .join("")}
</body>
</html>
        `;
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hour = String(now.getHours()).padStart(2, "0");
        const minute = String(now.getMinutes()).padStart(2, "0");
        const formattedDate = `date-${month}/${day}_time-${hour}:${minute}`;
        const fileName = `importer_debug_${formattedDate}.html`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <Modal
            modalType={ModalTypes.IMPORT_RESUME_DEBUG}
            open={isOpen}
            title="Import Resume Debug"
            width="7xl"
            forceFullHeight
        >
            <Button
                onClick={openDebugDetailsInNewTab}
                className="mb-4 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
                Open in new tab
            </Button>
            <Button
                onClick={downloadDebugDetailsAsHtml}
                className="mb-4 ml-2 rounded bg-green-600 px-4 py-2 text-white hover:bg-green-700"
            >
                Download
            </Button>
            {Object.entries(importerDebugDetails).map(([key, value]) => (
                <ExpandableDebugItem
                    key={key}
                    label={key}
                    value={value ?? "No value"}
                />
            ))}
        </Modal>
    );
};

export default ImporterDebugModal;
